/* eslint-disable complexity, react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';
import { branch, renderNothing } from 'recompose';
import log from '../../config/app.logger';
function isCookieStoreAvailable() {
    if ('cookieStore' in window) {
        log('cookieStore available, cookie change listeners will be registered');
        return true;
    }
    log('cookieStore not available, skipping cookie change listeners');
    return false;
}
function CookieChangeListener(props) {
    var onChange = props.onChange, onDelete = props.onDelete, _a = props.cookiesToMonitor, cookiesToMonitor = _a === void 0 ? [] : _a;
    var needToNotify = useCallback(function (cookies) {
        return cookies.find(function (_a) {
            var name = _a.name;
            return cookiesToMonitor.includes(name);
        });
    }, [cookiesToMonitor]);
    var onCookieChange = useCallback(function (event) {
        var _a, _b;
        if (((_a = event.changed) === null || _a === void 0 ? void 0 : _a.length) && onChange && needToNotify(event.changed)) {
            onChange(event.changed);
        }
        if (((_b = event.deleted) === null || _b === void 0 ? void 0 : _b.length) && onDelete && needToNotify(event.deleted)) {
            onDelete(event.deleted);
        }
    }, []);
    var registerHandlers = useCallback(function () {
        window.cookieStore.addEventListener('change', onCookieChange);
    }, []);
    var unregisterHandlers = useCallback(function () {
        window.cookieStore.removeEventListener('change', onCookieChange);
    }, []);
    useEffect(function () {
        registerHandlers();
        return unregisterHandlers;
    });
    return null;
}
export default branch(function () { return !isCookieStoreAvailable(); }, renderNothing)(CookieChangeListener);
//# sourceMappingURL=Listeners.js.map